import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
  OrganizationUser,
  OrganizationUserRole,
} from '../interfaces/organization_user.interface';
import { Organization } from '../interfaces/organization.interface';

export type User = {
  firstName: string;
  lastName: string;
  email: string;
  id: string;
};

type UserState = {
  user: User | null;
  organizationUser: OrganizationUser | null;
  organization: Organization | null;
  token: string | null;
  isLoading: boolean;
  error: boolean;
  role: OrganizationUserRole | null;
  authApp2FAenabled: boolean | null;
  email2FAEnabled: boolean | null;
};

const initialState: UserState = {
  user: null,
  organizationUser: null,
  organization: null,
  token: null,
  isLoading: false,
  error: false,
  role: null,
  authApp2FAenabled: null,
  email2FAEnabled: null,
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => {
    return {
      setUser(user: UserState) {
        patchState(store, user);
      },
      setToken(token: UserState['token']) {
        patchState(store, { token });
      },
      setOrganizationUser(organizationUser: UserState['organizationUser']) {
        patchState(store, { organizationUser });
      },
      setOrganization(organization: UserState['organization']) {
        patchState(store, { organization });
      },
      setRole(role: UserState['role']) {
        patchState(store, { role });
      },
      setIsLoading(isLoading: UserState['isLoading']) {
        patchState(store, { isLoading });
      },
      setAuthApp2FA(authApp2FAenabled: boolean) {
        patchState(store, { authApp2FAenabled });
      },
      setEmailApp2FA(email2FAEnabled: boolean) {
        patchState(store, { email2FAEnabled });
      },
      reset() {
        patchState(store, initialState);
      },
    };
  }),
);
